module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('size.label')
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.from.sizes,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.newItem.from.size),
      callback: function($$v) {
        _vm.$set(_vm.newItem.from, "size", $$v)
      },
      expression: "newItem.from.size"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('size.label'),
      "columns": 3
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.to.sizes,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.newItem.to.size),
      callback: function($$v) {
        _vm.$set(_vm.newItem.to, "size", $$v)
      },
      expression: "newItem.to.size"
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee47223","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/shopee/SizeAddItem.vue
// module id = 3210
// module chunks = 0